import i18n from '../i18n'
import { messages as frOriginalMessages } from 'vee-validate/dist/locale/fr'
import { messages as enOriginalMessages } from 'vee-validate/dist/locale/en'

export default {}

export const config = {
  events: 'input',
  locale : 'en',
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    en: {
      messages : enOriginalMessages,
      attributes: {
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        middleName: 'Middle Name',
        beltNum: 'Belt Number',
        parentFirstName: 'Parent First Name',
        parentLastName: 'Parent Last Name',
        password: 'Password',
        confirmPassword: 'Password',
        phoneNumber: 'Phone Number',
        parentPhoneNumber: 'Parent Phone Number',
        parentEmail: 'Parent Email',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm Password',
        dob: 'Date of Birth'
      },
      custom: {
        name: {
          required: 'Name field is required.'
        },
        phoneNumber: {
          regex: 'Only digits allowed with minimum length of 9.'
        },
        parentPhoneNumber: {
          regex: 'Only digits allowed with minimum length of 9.'
        },
        height: {
          numeric: 'Please insert numeric characters.'
        },
        weight: {
          decimal: 'The weight field must be numeric and may contain 1 decimal point.'
        },
        startMinutes: {
          regex: 'Please insert a valid number.'
        },
        startSeconds: {
          regex: 'Please insert a valid number.'
        },
        endMinutes: {
          regex: 'Please insert a valid number.'
        },
        endSeconds: {
          regex: 'Please insert a valid number.'
        },
      }
    },
    fr: {
      messages : frOriginalMessages,
      attributes: {
        email: 'Adresse courriel',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        middleName: 'Second prénom',
        beltNum: 'Numéro de la ceinture',
        parentFirstName: 'Prénom du parent',
        parentLastName: 'Nom de famille du parent',
        password: 'Mot de passe',
        confirmPassword: 'Mot de passe',
        phoneNumber: 'Numéro de téléphone',
        parentPhoneNumber: 'Numéro de téléphone du parent',
        parentEmail: 'Adresse courriel du parent',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirmNewPassword: 'Confirmez le nouveau mot de passe',
        dob: 'Date de naissance'
      },
      custom: {
        name: {
          required: '1Name field is required.'
        },
        phoneNumber: {
          regex: 'Only digits allowed with minimum length of 9.'
        },
        parentPhoneNumber: {
          regex: 'Only digits allowed with minimum length of 9.'
        },
        height: {
          numeric: 'Please insert numeric characters.'
        },
        weight: {
          decimal: 'The weight field must be numeric and may contain 1 decimal point.'
        },
        startMinutes: {
          regex: 'Please insert a valid number.'
        },
        startSeconds: {
          regex: 'Please insert a valid number.'
        },
        endMinutes: {
          regex: 'Please insert a valid number.'
        },
        endSeconds: {
          regex: 'Please insert a valid number.'
        },
      }
    }
  }
}
